import { z } from 'zod'

import { columnsSchema, paginationSchema, sortingSchema } from '@/utils/zod'

const schoolYearAndBreakCommonFilterSchema = z.object({
  status: z.union([z.literal('active-and-future'), z.literal('past')]),
  ...paginationSchema.shape,
  ...columnsSchema.shape
})

export type SchoolYearAndBreakCommonFilter = z.infer<
  typeof schoolYearAndBreakCommonFilterSchema
>

export const schoolYearsFilterSchema = z.object({
  search: z.string().optional(),
  ...schoolYearAndBreakCommonFilterSchema.shape,
  ...sortingSchema.shape
})

export const schoolBreaksFilterSchema = z.object({
  search: z.string().optional(),
  dateAfter: z.string().optional(),
  dateBefore: z.string().optional(),
  year: z.array(z.string()).optional(),
  ...schoolYearAndBreakCommonFilterSchema.shape
})

type SchoolBreaksFilter = z.infer<typeof schoolBreaksFilterSchema>
export type SchoolBreaksFilterKey = keyof SchoolBreaksFilter
